export default "__VITE_ASSET__eXJG0XKM__"